import { WEAVR_OWT_DESCRIPTION_MAX_LENGTH } from "@finway-group/shared/lib/consts/weavr"
import { Rule } from "antd/lib/form"
import { parseCurrencyInput } from "~Components/currencyInput/config"
import { i18n } from "~Shared/locales/i18n"
import { isValidAccountNumber, isValidBIC, isValidIBAN, isValidSortCode } from "~Shared/utils/helper.utils"

export const createWalletRules = () => ({
    required: [{ required: true, message: i18n.t("validation:required") }] as Array<Rule>,
    amount: [
        { required: true, message: i18n.t("validation:required") },
        {
            validator: (_rule, inputValue: string) => {
                const inputValueString = inputValue ? inputValue.toString() : ""
                if (inputValueString !== "") {
                    const inputValueParsed = parseCurrencyInput(inputValue)
                    if (inputValueParsed <= 0) {
                        return Promise.reject(new Error(i18n.t("validation:greater.number", { min: 0 })))
                    }

                    return Promise.resolve()
                }

                return Promise.reject(new Error(i18n.t("validation:not_zero")))
            },
        },
    ] as Array<Rule>,
    description: [
        { required: true, message: i18n.t("validation:required") },
        {
            max: WEAVR_OWT_DESCRIPTION_MAX_LENGTH,
            message: i18n.t("validation:max.string", { max: WEAVR_OWT_DESCRIPTION_MAX_LENGTH }),
        },
    ] as Array<Rule>,
    countryCode: [
        {
            validator: (_rule, value: string) => {
                if (value && value !== "") {
                    if (value.length !== 2) {
                        return Promise.reject(new Error(i18n.t("validation:exact.string", { num: 2 })))
                    }
                    if (!/[A-Z]{2}/.test(value)) {
                        return Promise.reject(new Error(i18n.t("validation:only_uppercase")))
                    }
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    iban: [
        {
            validator: (_rule, value: string) => {
                if (!value) {
                    return Promise.reject(i18n.t("validation:required"))
                }
                if (value && value !== "" && !isValidIBAN(value)) {
                    return Promise.reject(new Error(i18n.t("validation:iban")))
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    bic: [
        {
            validator: (_rule, value: string) => {
                if (!value) {
                    return Promise.reject(i18n.t("validation:required"))
                }
                if (value && value !== "" && !isValidBIC(value)) {
                    return Promise.reject(new Error(i18n.t("validation:bic")))
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    accountNumber: [
        {
            validator: (_rule, value: string) => {
                if (!value) {
                    return Promise.reject(i18n.t("validation:required"))
                }
                if (value && value !== "" && !isValidAccountNumber(value)) {
                    return Promise.reject(new Error(i18n.t("validation:account_number")))
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    sortCode: [
        {
            validator: (_rule, value: string) => {
                if (!value) {
                    return Promise.reject(i18n.t("validation:required"))
                }
                if (value && value !== "" && !isValidSortCode(value)) {
                    return Promise.reject(new Error(i18n.t("validation:sort_code")))
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
})
